import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteAPhotograph, getPhotographs, resetState } from "../features/PhotographsSlice";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Logo",
    dataIndex: "logo",
    render: logo => <img src={logo} alt="Photograph Logo" style={{ width: 50, height: 50 }} />,
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const PhotographsList = () => {
  const [open, setOpen] = useState(false);
  const [PhotographId, setPhotographId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setPhotographId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getPhotographs());
  }, []);
  const getPhotographState = useSelector((state) => state.Photograph.Photographs);
  console.log(getPhotographState);
  const data1 = [];
  console.log(getPhotographState.length);
  for (let i = 0; i < getPhotographState.length; i++) {
    data1.push({
      key: i + 1,
      logo: getPhotographState[i].image,

      action: (
        <>
          <Link
            to={`/admin/Add-Photograph/${getPhotographState[i]._id}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(getPhotographState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteNews = (e) => {
    dispatch(deleteAPhotograph(e));

    setOpen(false);
    setTimeout(() => {
      dispatch(getPhotographs());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Photograph List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteNews(PhotographId);
        }}
        title="Are you sure you want to delete this Photograph?"
      />
    </div>
  );
};

export default PhotographsList;
